import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Branch } from '../../entities/control-tables/branch-entity';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

 

export class BranchRequest extends BaseRequest{
  branch : Branch;
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.branch = new Branch();
  }
}